import 'intl-tel-input';
import * as intlTelInput from 'intl-tel-input';

var formIntlTelInput = {
	/**
	 * Init
	 *
	 * @param {object} target
	 *
	 * @returns {void}
	 */
	init: async function (target) {
		window.itiInstances = {};

		const utilsScript = await import('intl-tel-input/build/js/utils.js');

		target.querySelectorAll('[data-init-IntlTelInput]').forEach(function (element) {
			if (typeof window.intlTelInput === 'undefined') {
				window.intlTelInput = intlTelInput;
			}

			const elementIdentifier = formIntlTelInput.generateId();
			element.setAttribute('data-iti-id', elementIdentifier);

			window.itiInstances[elementIdentifier] = window.intlTelInput(element, {
				autoPlaceholder: 'aggressive',
				initialCountry: 'nl',
				placeholderNumberType: 'FIXED_LINE',
				preferredCountries: ['nl', 'be', 'de', 'gb', 'lu'],
				utilsScript: utilsScript,
			});
		});
	},

	/**
	 * Generate unique ID
	 *
	 * @returns {string}
	 */
	generateId: function () {
		return 'iti-' + Math.random().toString(36).substring(2, 20);
	},
};

export default formIntlTelInput;
